import { render, staticRenderFns } from "./pdfdocCatalog.vue?vue&type=template&id=4e6f757b&scoped=true&"
import script from "./pdfdocCatalog.vue?vue&type=script&lang=js&"
export * from "./pdfdocCatalog.vue?vue&type=script&lang=js&"
import style0 from "./pdfdocCatalog.vue?vue&type=style&index=0&id=4e6f757b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6f757b",
  null
  
)

export default component.exports